/**
 * 移动端页面基类,用于注入移动端刷新页面，刷新keepalive缓存
 */
export default {
  computed: {
    ...mobileDefaultComputed()
  },
  methods: {
    ...mobileDefaultFunction(),
    $popRefresh(mark = true) {
      if (this.$refreshQueue && this.$refreshQueue[this.$route.path]) {
        try {
          this?.$removeRefresh?.(this.$route.path);
          mark && this?.reloadData?.();
        } catch (ex) {
          if (dsf.isError(ex)) {
            dsf.error("刷新" + this.$route.path + "失败");
          }
        }
      }
    }
  }
};

function mobileDefaultComputed() {
  try {
    let fns = Vuex.mapState("refreshQueue", {
      $refreshQueue: "queue"
    });
    return fns;
  } catch (ex) {
    return {};
  }
}

function mobileDefaultFunction() {
  try {
    let fns = Vuex.mapMutations("refreshQueue", {
      $pushRefresh: "add",
      $removeRefresh: "remove"
    });
    return fns;
  } catch (ex) {
    return {};
  }
}
